<template>
    <transition name="fade">
        <div class="row mx-auto w-100"  v-if="formstate">
        <div class="col-12 w-100 px-0 my-2 py-0">
            <div class="row p-3 mx-2 bg-white" :class="[noshadow?'':'shadow']">
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">{{dicts.label_nama_kapal[lang]}} <span style="color:red;">*</span></label>
                    <input type="text"  class="form-control w-100 rounded" v-model="newvessel.name" />
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">{{dicts.label_legal[lang]}}</label>
                    <input type="text"  class="form-control w-100 rounded" v-model="newvessel.name_legal " />
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-inline">{{dicts.label_pemilik[lang]}} <span style="color:red;">*</span></label> <button type="button" @click="openCreateClientPopup" class="btn d-inline btn-sm rounded-pill ml-2"><span style="font-size:20px">+</span></button>
                    <smart-search direct :search-value="newvessellabel" init url="/api/master/seeker/pengguna" usedefault :default-value="newvessellabel" key-tag="first_name" :label-tag="['customer_id','legal_name']" v-on:update="(data)=>smartSearchAddClient(data)"  @update-direct="(label)=>newvessellabel=label"></smart-search>
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">{{dicts.label_category_kapal[lang]}}</label>
                    <smart-select name="status" :options="statusCategoryOptions" v-on:update="updateNewVesselCategory"></smart-select>
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">{{dicts.label_tipe_kapal[lang]}}</label>
                    <input type="text"  class="form-control w-100 rounded" v-model="newvessel.type_vessel" />
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">Radio</label>
                    <input type="text"  class="form-control w-100 rounded" v-model="newvessel.radio" />
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">GT</label>
                    <input type="text"  class="form-control w-100 rounded" v-model="newvessel.gt" />
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">Selar Sign</label>
                    <input type="text"  class="form-control w-100 rounded" v-model="newvessel.selar_sign" />
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">{{dicts.label_material[lang]}}</label>
                    <input type="text"  class="form-control w-100 rounded" v-model="newvessel.material" />
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">{{dicts.label_panjang[lang]}}</label>
                    <input type="number"  class="form-control w-100 rounded" v-model="newvessel.panjang" />
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">{{dicts.label_lebar[lang]}}</label>
                    <input type="number"  class="form-control w-100 rounded" v-model="newvessel.lebar" />
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">{{dicts.label_power_boat[lang]}}</label>
                    <input type="text"  class="form-control w-100 rounded" v-model="newvessel.power_boat" />
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">{{dicts.label_merk_mesin[lang]}}</label>
                    <input type="text"  class="form-control w-100 rounded" v-model="newvessel.merk_mesin" />
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">{{dicts.label_no_mesin[lang]}}</label>
                    <input type="text"  class="form-control w-100 rounded" v-model="newvessel.no_mesin" />
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">Groos Deed</label>
                    <input type="text"  class="form-control w-100 rounded" v-model="newvessel.gross_deed" />
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">{{dicts.label_tahun_pembuatan[lang]}}</label>
                    <input type="number"  class="form-control w-100 rounded" v-model="newvessel.tahun_pembuatan" />
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">{{dicts.label_alamat_pembuatan[lang]}}</label>
                    <input type="text"  class="form-control w-100 rounded" v-model="newvessel.alamat_pembuatan" />
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">No Sipi</label>
                    <input type="text"  class="form-control w-100 rounded" v-model="newvessel.no_sipi" />
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">{{dicts.label_flag[lang]}}</label>
                    <input type="text"  class="form-control w-100 rounded" v-model="newvessel.flag" />
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">{{dicts.label_start_sipi[lang]}}</label>
                    <b-form-datepicker today-button reset-button close-button :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}" id="datepicker-start-sipi" v-model="newvessel.start_sipi" class="mb-2"></b-form-datepicker>
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">{{dicts.label_end_sipi[lang]}}</label>
                    <b-form-datepicker today-button reset-button close-button :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}" id="datepicker-end-sipi" v-model="newvessel.end_sipi" class="mb-2"></b-form-datepicker>
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">No Registrasi RMOF</label>
                    <input type="text"  class="form-control w-100 rounded" v-model="newvessel.no_registrasi_rmof" />
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                <label class="d-block">Status</label>
                <smart-select name="status" :options="statusTypeOptions" v-on:update="updateNewVesselStatus"></smart-select>
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">{{dicts.label_user_update[lang]}}</label>
                    <input type="text"  class="form-control w-100 rounded" v-model="newvessel.user_update" readonly />
                </div>
                <div class="col-12 mt-3">
                    <div class="w-100 align-items-center justify-content-start" v-if="newvesselSaved">
                        <div class="alert alert-success" role="alert">
                            Berhasil menyimpan vessel baru.
                        </div>
                    </div>
                </div>
                <div class="col-12 mt-3">
                    <div class="w-100 align-items-center justify-content-start" v-if="errorNewvessel">
                        <div class="alert alert-danger" role="alert">
                            <div class="my-0">
                                <p  class="d-block mt-1">Gagal menyimpan vessel baru.</p>
                            </div>
                            <div v-for="err in errorNewvesselList" v-bind:key="err" class="my-0">
                                <p  v-for="note in err" v-bind:key="note" class="d-block mt-1">{{note}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 mt-3">
                    <div class="d-flex align-items-center justify-content-start" v-if="savingNewvessel">
                        <div class="spinner-border" role="status" aria-hidden="true"></div>
                        <strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
                    </div>
                    <button class="btn btn-primary float-right" type="button" v-on:click="saveNewvessel">Submit</button>
                </div>
            </div>
        </div>
        </div>
    </transition>
</template>
<script>
import {EventBus} from '../eventbus'
import * as axios from 'axios';
import SmartSelect from './SmartSelect';
import SmartSearch from './SmartSearch.vue';
export default {
    components: {
        'smart-select':SmartSelect,
        'smart-search':SmartSearch
    },
    props:{
        formstate:{
            type:Boolean,
            default:false
        },
        noshadow:{
            type:Boolean,
            default:false
        },
        lang:{
            type:String,
            default:'id'
        }
    },
    data(){
        return {
            newvessellabel:'',
            itemTypeOptions:[
                {label:'Antena',value:'antena'},
                {label:'JB',value:'jb'},
            ],
            statusTypeOptions:[
                {label:'Aktif',value:'active'},
                {label:'Tidak aktif',value:'inactive'},
            ],
            statusCategoryOptions:[
                {label:'KKP',value:'KKP'},
                {label:'SWASTA',value:'SWASTA'},
            ],
            newvessel:{
                name:'',
                name_legal:'',
                client_id:'',
                no_sipi:'',
                start_sipi:'',
                end_sipi:'',
                flag:'',
                type_vessel:'',
                radio:'',
                gt:'',
                selar_sign:'',
                material:'',
                panjang:'',
                lebar:'',
                power_boat:'',
                merk_mesin:'',
                no_mesin:'',
                gross_deed:'',
                tahun_pembuatan:'',
                alamat_pembuatan:'',
                no_registrasi_rmof:'',
                status:'active',
                user_update:'',
                vessel_category:'KKP'
            },
            errorNewvessel:false,
            savingNewvessel:false,
            newvesselSaved:false,
            dicts:{
                    label_nama_kapal:{
                        id:"Nama kapal",
                        en:"Vessel name"
                    },
                    label_legal:{
                        id:"Nama legal kapal",
                        en:"Vessel name legal"
                    },
                    label_pemilik:{
                        id:"Pemilik",
                        en:"Client"
                    },
                    label_category_kapal:{
                        id:"Kategori kapal",
                        en:"Vessel category"
                    },
                    label_tipe_kapal:{
                        id:"Tipe kapal",
                        en:"Vessel type"
                    },
                    label_material:{
                        id:"Bahan",
                        en:"Material"
                    },
                    label_panjang:{
                        id:"Panjang",
                        en:"Lenght"
                    },
                    label_lebar:{
                        id:"Lebar",
                        en:"Width"
                    },
                    label_power_boat:{
                        id:"Perahu motor",
                        en:"Power boat"
                    },
                    label_merk_mesin:{
                        id:"Merk mesin",
                        en:"Machine brand"
                    },
                    label_no_mesin:{
                        id:"No mesin",
                        en:"Engine no"
                    },
                    label_tahun_pembuatan:{
                        id:"Tahun Pembuatan",
                        en:"Production year"
                    },
                    label_alamat_pembuatan:{
                        id:"Alamat pembuatan",
                        en:"Production address"
                    },
                    label_flag:{
                        id:"Negara",
                        en:"Flag"
                    },
                    label_start_sipi:{
                        id:"Mulai sipi",
                        en:"Start sipi"
                    },
                    label_end_sipi:{
                        id:"Selesai sipi",
                        en:"End sipi"
                    },
                    label_user_update:{
                        id:"Pembaruan pengguna",
                        en:"User update"
                    },
                }
        }
    },
    created(){
        this.newvessel.user_update = localStorage.getItem("currentUser");
        window.onstorage = () => {
            var temp = JSON.parse(localStorage.getItem('datavessel'));
            console.log(temp)
            this.newvessel.client_id=temp.data.id
            this.newvessellabel=temp.data.first_name
        };
    },
    methods:{
        smartSearchAddClient(data){
            this.newvessel.client_id=data.id
        },
        createVesselCallback(result,data={}){
            this.$emit("createvessel",{status:result,data:data})
        },
        openCreateClientPopup(){
            window.open('/#/admin/datamaster/create-popup-klien','CreatePengguna','toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=yes,width=800'); 
        },
        saveNewvessel(){
            this.savingNewvessel=true
            this.errorNewvessel=false
            console.log(this.newvessel)
            this.errorNewvesselList=[]
            if(this.newvessel.name==''){
                this.errorNewvesselList.push(["- Mohon Isi Nama Kapal"])
            }
            if(this.newvessel.client_id==''){
                this.errorNewvesselList.push(["- Mohon Isi Nama Pelanggan"])
            }
            console.log(this.errorNewvesselList)

            if(
                this.newvessel.name!='' && 
                this.newvessel.client_id!=''
            // && this.newvessel.no_sipi!='' && this.newvessel.start_sipi!='' && this.newvessel.end_sipi!='' && this.newvessel.flag!='' && this.newvessel.type_vessel!='' && this.newvessel.radio!='' && this.newvessel.gt!='' && this.newvessel.selar_sign!='' && this.newvessel.material!='' && this.newvessel.panjang!='' && this.newvessel.lebar!='' && this.newvessel.power_boat!='' && this.newvessel.merk_mesin!='' && this.newvessel.no_mesin!='' && this.newvessel.gross_deed!='' && this.newvessel.tahun_pembuatan!='' && this.newvessel.alamat_pembuatan!='' && this.newvessel.no_registrasi_rmof!='' && this.newvessel.status!='' && this.newvessel.user_update!=''
            ){
                var readyToStore = {}
                for (var key of Object.keys(this.newvessel)) {
                    if(this.newvessel[key]!=''){
                        readyToStore[key]=this.newvessel[key]
                    }
                }
                // console.log(readyToStore)
                axios.post(this.$baseUrl+'/api/master/vessel',readyToStore,{
                    'headers':
                    {
                        'Authorization':'Bearer '+localStorage.getItem('accessToken')
                    }
                }).then((result)=>{
                    // console.log('create ok')
                    // console.log(result)
                    
                    if(result.success=200){
                        this.createVesselCallback(true,result.data.data)
                        this.newvesselSaved=true
                    }else{
                        this.createVesselCallback(false)
                    }
                    // this.newvessel.vesselName='name',
                    // this.newvessel.itemType='antena',
                    
                    setTimeout(() => {
                        this.newvesselSaved=false
                        this.formNewvessel=false
                        this.formstate=false
                    }, 1000);
                    this.savingNewvessel=false

                }).catch((err)=>{
          //check if token fail
          if(err.response && err.response.status==401){
            localStorage.removeItem('accessToken')
          this.$router.push('/login')
          }
                    console.log(err.response)
                    this.errorNewvesselList=[]
                    this.errorNewUserList=Object.values(err.response.data.errors)
                    console.log(this.errorNewUserList)
                    this.errorNewvessel=true
                    this.savingNewvessel=false
                    this.createVesselCallback(false)
                })
            }else{
                console.log('missing input')
                this.errorNewvessel=true
                this.savingNewvessel=false
                this.$emit('createvessel',false)
            }
        },
        resetNewVesselData(){
            this.newvessel.name='',
            this.newvessel.name_legal='',
            this.newvessel.client_id='',
            this.newvessel.no_sipi='',
            this.newvessel.start_sipi='',
            this.newvessel.end_sipi='',
            this.newvessel.flag='',
            this.newvessel.type_vessel='',
            this.newvessel.radio='',
            this.newvessel.gt='',
            this.newvessel.selar_sign='',
            this.newvessel.material='',
            this.newvessel.panjang='',
            this.newvessel.lebar='',
            this.newvessel.power_boat='',
            this.newvessel.merk_mesin='',
            this.newvessel.no_mesin='',
            this.newvessel.gross_deed='',
            this.newvessel.tahun_pembuatan='',
            this.newvessel.alamat_pembuatan='',
            this.newvessel.no_registrasi_rmof='',
            this.newvessel.status='active',
            this.newvessel.user_update='',
            this.newvessel.vessel_category='KKP',
            this.savingNewvessel=false,
            this.newvesselSaved=true
            },
    }
}
</script>
<style scoped>
.btn-sm, .btn-group-sm > .btn {
    line-height: 0.5;
}
.btn-sm {
    padding: 5px;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>